import React, {useContext, useEffect} from 'react'
import Layout from '../../../components/layout/layout'
import '../mlOutRails/mlOutRails.scss'
import ecommerceImage from '../../../images/articles/ecommerce-photo.jpg'
import { LanguageContext } from '../../../components/LanguageSwitcher/LanguageContext'
import { ArticleBackLink, ArticleNextCta } from '../../../components/ArticleNav/ArticleNav'
import ArticleCta from '../../../components/ArticleCta/ArticleCta'
import ArticleListen from '../../../components/ArticleListen/ArticleListen'
import ArticleSummary from '../../../components/ArticleSummary/ArticleSummary'
import Seo, { articleJsonLd, articleBreadcrumbs } from '../../../components/Seo/Seo'


const MlEcommerce = () => {
  const { translations } = useContext(LanguageContext);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Layout>
      <Seo
        title='Machine Learning in E-Commerce: Data to Sales'
        description={translations.BlogMlEcommerce1}
        type='article'
        image={ecommerceImage}
        jsonLd={[
          articleJsonLd({ headline: translations.BlogMlEcommerce, description: translations.BlogMlEcommerce1, datePublished: '2026-03-18', author: translations.BlogMlEcommerce12 }),
          articleBreadcrumbs(translations.BlogMlEcommerce, '/articles/mlEcommerce'),
        ]}
      />
      <div className='mlrole-health-container'>

        <div className='mlrole-health healthh-box'>
          <ArticleBackLink />
          <h1 className='article-main-title'>{translations.BlogMlEcommerce}</h1>
          <div className='article-author-head-container'>
            <div className='article-author-head'>
              <p>{translations.BlogMlEcommerce11}</p>
              <p>•</p>
              <p>{translations.BlogMlEcommerce12}</p>
            </div>
            <p className='article-author-head'>{translations.BlogMlEcommerce13}</p>
          </div>

          <div className='mlrole-health-first-image-box'>
            <img src={ecommerceImage} alt='Man paying online with a credit card on his laptop' className='mlrole-health-first-image' />
          </div>
          <ArticleListen />
          <ArticleSummary id='mlEcommerce' />
          <div className='mlrole-health-txt-container'>
            <div className='mlrole-health-txt-child-box'>
              <p>{translations.BlogMlEcommerce1}</p>
              <p>{translations.BlogMlEcommerce2}</p>

              <h2 className='article-secondaty-title'>{translations.BlogMlEcommerce3}</h2>
              <p>{translations.BlogMlEcommerce4}</p>
              <p>{translations.BlogMlEcommerce5}</p>
              <p>{translations.BlogMlEcommerce6}</p>

              <h2 className='article-secondaty-title'>{translations.BlogMlEcommerce7}</h2>
              <p>{translations.BlogMlEcommerce8}</p>
              <p>{translations.BlogMlEcommerce9}</p>
              <p>{translations.BlogMlEcommerce10}</p>
            </div>
          </div>

          <ArticleCta />
          <ArticleNextCta link='/articles/digitalHealth' title={translations.BlogDigitalHealth} />
        </div>
      </div>
    </Layout>
  )
}

export default MlEcommerce
